export const initial = {};

export default (state = initial, action = {}) => {
  switch (action.type) {
    case 'RANKING_DETAILS_REQUESTED':
      return {
        ...state,
        requestedId: action.payload,
        notFound: false,
      };
    case 'RANKING_DETAILS_SET':
      return {
        ...action.payload,
        requestedId: action.payload?._id,
        notFound: false,
      };
    case 'RANKING_DETAILS_REMOVED':
      return initial;
    case 'RANKING_NOT_FOUND':
      return {
        ...state,
        notFound: true,
      };
    default:
      return state;
  }
};
